import React, { useState } from 'react';
import axios from 'axios';
import { MAX_HOME_TILES } from '../data/staffTiles';
import '../pages/booking/booking-shared.css';

// Choose up to six home screen tiles. Picks keep the order they were ticked in.
export default function HomeTilePicker({ tiles, current, onSaved, onClose }) {
  const [picked, setPicked] = useState(current);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const full = picked.length >= MAX_HOME_TILES;

  const toggle = id => setPicked(prev => (prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]));

  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const res = await axios.put('/api/users/profile', { homeTiles: picked });
      onSaved(res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || "Couldn't save your tiles. Try again.");
      setSaving(false);
    }
  };

  const groups = [];
  tiles.forEach(t => {
    const name = t.section || 'General';
    let g = groups.find(x => x.name === name);
    if (!g) groups.push(g = { name, tiles: [] });
    g.tiles.push(t);
  });

  return (
    <div className="bk-modal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bk-modal home-tile-picker" role="dialog" aria-labelledby="home-tile-picker-title" style={{ maxWidth: 520 }}>
        <h3 id="home-tile-picker-title" style={{ margin: 0 }}>Home screen tiles</h3>
        <p className="bk-muted" style={{ margin: '0.25rem 0 1rem', fontSize: '0.9rem' }}>
          Pick up to {MAX_HOME_TILES}. {picked.length} of {MAX_HOME_TILES} chosen.
        </p>
        {groups.map(g => (
          <fieldset key={g.name} className="home-tile-picker__group">
            <legend>{g.name}</legend>
            {g.tiles.map(t => {
              const on = picked.includes(t.id);
              return (
                <label key={t.id} className={`home-tile-picker__option${!on && full ? ' home-tile-picker__option--disabled' : ''}`}>
                  <input type="checkbox" checked={on} disabled={!on && full} onChange={() => toggle(t.id)} />
                  <t.icon className="home-tile-picker__icon" aria-hidden="true" />
                  {t.label}
                  {on && <span className="home-tile-picker__order">{picked.indexOf(t.id) + 1}</span>}
                </label>
              );
            })}
          </fieldset>
        ))}
        {error && <p className="bk-error" role="alert">{error}</p>}
        <div className="home-tile-picker__actions">
          <button type="button" className="bk-btn bk-btn--outline" onClick={onClose}>Cancel</button>
          <button type="button" className="bk-btn bk-btn--primary" onClick={save} disabled={saving || picked.length === 0}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
